import { render } from "./layout-page.vue?vue&type=template&id=02bd91ea"
const script = {}

import "./layout-page.vue?vue&type=style&index=0&id=02bd91ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__